import { ROUTES } from "../routes/routePaths";
import useAppStore from "../store/useAppStore";

/**
 * Returns the correct "back" route based on which screen launched the booster flow.
 * - "stage3Booster" → STAGE3_BOOSTERS
 * - "stage4Boosters" (or anything else) → NEXT_STEPS
 */
export const getBoosterBackRoute = () => {
  const { boosterSource } = useAppStore.getState();
  return boosterSource === "stage3" ? ROUTES.STAGE3_BOOSTERS : ROUTES.NEXT_STEPS;
};
